(function () {
  class PackContentsElement extends HTMLElement {
    connectedCallback() {
      this.packSwitcher = document.querySelector('.pack-switcher[data-active-pack-key]');
      this.items = this.querySelectorAll('.pack-item[data-pack-key]');
      this.bonusItems = this.querySelectorAll('.pack-item[data-pack-bonus]');

      var colorTriggersAttr = this.getAttribute('data-color-triggers') || 'Color';
      this._colorTriggers = colorTriggersAttr.split(',').map(function (s) {
        return s.trim().toLowerCase();
      });

      var pricesAttr = this.getAttribute('data-parent-variant-prices');
      this._parentVariantPrices = {};
      if (pricesAttr) {
        try { this._parentVariantPrices = JSON.parse(pricesAttr); } catch (e) {}
      }

      this._moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
      this._defaultParentVariantId = this.getAttribute('data-default-parent-variant-id') || '';

      this.state = {
        activeKey: this.getActivePackKey(),
        masterColor: '',
        rows: {}
      };

      // AbortController for all event listeners — cleaned up in disconnectedCallback
      this._ac = new AbortController();

      this.applyVisibility();
      this.initRowStates();
      this.initChangeColorToggles();
      this.initSwatchPickers();

      // Set up ATC interception immediately (not deferred) so it's ready
      // before the user can click.
      this.initPackAddToCart();

      // Defer sibling-dependent init (master color sync, pricing) to next frame
      // so the variant picker and product form are connected first.
      var self = this;
      this._initRAF = requestAnimationFrame(function () {
        self._initRAF = null;
        if (!self.isConnected) return;
        try {
          self.readMasterColor();
          self.syncMasterColor(false);
          self.initMasterColorObserver();
        } catch (e) {
          console.warn('[pack-contents] master-color init error:', e);
        }
        try {
          self.updatePricing();
        } catch (e) {
          console.warn('[pack-contents] pricing init error:', e);
        }
      });
    }

    getActivePackKey() {
      if (!this.packSwitcher) return '';
      return this.packSwitcher.getAttribute('data-active-pack-key') || '';
    }

    isPackMode() {
      return this.state.activeKey !== '' || !this.packSwitcher;
    }

    /* ── Visibility ── */

    applyVisibility() {
      var activeKey = this.getActivePackKey();

      if (!activeKey && !this.packSwitcher) {
        var hasAny = false;
        this.items.forEach(function (item) { item.removeAttribute('hidden'); hasAny = true; });
        if (hasAny) this.removeAttribute('hidden');
        else this.setAttribute('hidden', '');
        return;
      }

      if (!activeKey) { this.setAttribute('hidden', ''); return; }

      var hasVisible = false;
      this.items.forEach(function (item) {
        if ((item.getAttribute('data-pack-key') || '') === activeKey) {
          item.removeAttribute('hidden');
          hasVisible = true;
        } else {
          item.setAttribute('hidden', '');
        }
      });

      if (hasVisible) this.removeAttribute('hidden');
      else this.setAttribute('hidden', '');
    }

    /* ── Row state — keyed by "packKey:rowNum" for uniqueness ── */

    initRowStates() {
      var self = this;
      var activeKey = this.state.activeKey;

      this.items.forEach(function (item) {
        var itemKey = item.getAttribute('data-pack-key') || '';
        if (self.packSwitcher && itemKey !== activeKey) return;

        var rowNum = item.getAttribute('data-pack-row') || '0';
        var stateKey = itemKey + ':' + rowNum;

        var activeSwatch = item.querySelector('.pack-item__swatch--active');
        var color = activeSwatch ? (activeSwatch.getAttribute('data-value') || '') : '';

        self.state.rows[stateKey] = {
          variantId: item.getAttribute('data-variant-id') || '',
          color: color,
          available: true,
          manuallyChanged: false
        };
      });
    }

    /* ── Colour pickers ── */

    initChangeColorToggles() {
      var signal = this._ac.signal;
      this.querySelectorAll('.pack-item__change-color').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.pack-item');
          var picker = item.querySelector('.pack-item__color-picker');
          if (!picker) return;
          var isOpen = !picker.hidden;
          picker.hidden = isOpen;
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }, { signal: signal });
      });
    }

    initSwatchPickers() {
      var self = this;
      var signal = this._ac.signal;
      this.querySelectorAll('.pack-item__swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.disabled) return;

          var item = swatch.closest('.pack-item');
          self.selectSwatch(item, swatch);

          var sk = self._stateKey(item);
          if (sk && self.state.rows[sk]) {
            self.state.rows[sk].manuallyChanged = true;
          }

          self.hideWarning(item);

          var picker = item.querySelector('.pack-item__color-picker');
          var btn = item.querySelector('.pack-item__change-color');
          if (picker) picker.hidden = true;
          if (btn) btn.setAttribute('aria-expanded', 'false');

          self.updatePricing();
        }, { signal: signal });
      });
    }

    _stateKey(item) {
      var pk = item.getAttribute('data-pack-key') || '';
      var rn = item.getAttribute('data-pack-row') || '0';
      return pk + ':' + rn;
    }

    /* ── Master colour reading ── */

    readMasterColor() {
      var variantPicker = document.querySelector('.block-product__variant-picker');
      if (!variantPicker) return;
      var variantInput = variantPicker.querySelector('variant-input');
      if (!variantInput) return;
      var optionNamesStr = variantInput.getAttribute('data-option-names');
      if (!optionNamesStr) return;

      var optionNames;
      try { optionNames = JSON.parse(optionNamesStr); } catch (e) { return; }

      var colorPos = -1;
      for (var i = 0; i < optionNames.length; i++) {
        if (this._colorTriggers.indexOf(optionNames[i].toLowerCase().trim()) !== -1) {
          colorPos = i; break;
        }
      }
      if (colorPos === -1) return;

      var fieldsets = variantInput.querySelectorAll('fieldset');
      var colorFieldset = fieldsets[colorPos];
      if (!colorFieldset) return;

      var valueSpan = colorFieldset.querySelector('.option_value');
      if (valueSpan) {
        this.state.masterColor = valueSpan.textContent.trim();
      }
    }

    initMasterColorObserver() {
      var self = this;
      var variantPicker = document.querySelector('.block-product__variant-picker');
      if (!variantPicker) return;

      this._variantObserver = new MutationObserver(function () {
        if (self._syncDebounce) return;
        self._syncDebounce = requestAnimationFrame(function () {
          self._syncDebounce = null;
          if (!self.isConnected) return;
          var oldColor = self.state.masterColor;
          self.readMasterColor();
          if (self.state.masterColor && self.state.masterColor !== oldColor) {
            self.syncMasterColor(true);
          }
          self.updatePricing();
        });
      });

      this._variantObserver.observe(variantPicker, { childList: true, subtree: true });
    }

    /* ── Sync master colour to all pack rows ── */

    syncMasterColor(resetManual) {
      var masterColor = this.state.masterColor;
      if (!masterColor) return;

      var self = this;
      var activeKey = this.state.activeKey;

      this.items.forEach(function (item) {
        if (self.packSwitcher) {
          if ((item.getAttribute('data-pack-key') || '') !== activeKey) return;
        }
        if (item.hidden) return;

        var sk = self._stateKey(item);
        if (!sk) return;
        var rowState = self.state.rows[sk];
        if (!rowState) return;

        if (resetManual) rowState.manuallyChanged = false;
        if (rowState.manuallyChanged) return;

        var swatches = item.querySelectorAll('.pack-item__swatch');
        if (swatches.length === 0) return;

        var matchingSwatch = null;
        var masterLower = masterColor.toLowerCase().trim();

        swatches.forEach(function (sw) {
          if ((sw.getAttribute('data-value') || '').toLowerCase().trim() === masterLower) {
            matchingSwatch = sw;
          }
        });

        if (!matchingSwatch) return;

        if (matchingSwatch.disabled) {
          rowState.available = false;
          self.showWarning(item, masterColor);
        } else {
          rowState.available = true;
          self.selectSwatch(item, matchingSwatch);
          self.hideWarning(item);
        }
      });
    }

    /* ── Swatch selection ── */

    selectSwatch(item, swatch) {
      var list = item.querySelector('.pack-item__swatches');
      if (list) {
        list.querySelectorAll('.pack-item__swatch').forEach(function (s) {
          s.classList.remove('pack-item__swatch--active');
        });
      }
      swatch.classList.add('pack-item__swatch--active');

      var variantId = swatch.getAttribute('data-variant-id');
      if (variantId) item.setAttribute('data-variant-id', variantId);

      var newImg = swatch.getAttribute('data-variant-image');
      var img = item.querySelector('.pack-item__image img');
      if (newImg && img) img.src = newImg;

      var sp = swatch.getAttribute('data-variant-price');
      var sc = swatch.getAttribute('data-variant-compare-price');
      if (sp) item.setAttribute('data-item-price', sp);
      if (sc) item.setAttribute('data-item-compare-price', sc);

      // Update per-item value pill
      var pill = item.querySelector('.pack-item__pill');
      if (pill) {
        var cp = parseInt(sc, 10) || 0;
        if (cp <= 0) cp = parseInt(sp, 10) || 0;
        if (cp > 0) pill.textContent = 'Value ' + this.formatMoney(cp);
      }

      var sk = this._stateKey(item);
      if (sk && this.state.rows[sk]) {
        this.state.rows[sk].color = swatch.getAttribute('data-value') || '';
        this.state.rows[sk].variantId = variantId || '';
      }
    }

    /* ── Money formatting ── */

    formatMoney(cents) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      cents = parseInt(cents, 10) || 0;
      var dollars = (cents / 100).toFixed(2);
      var noDec = Math.round(cents / 100).toString();
      return this._moneyFormat
        .replace('{{amount_with_comma_separator}}', dollars.replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', noDec.replace(/(\d)(?=(\d{3})+$)/g, '$1,').replace(',', '.'))
        .replace('{{amount_with_apostrophe_separator}}', dollars.replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace('.', "'"))
        .replace('{{amount_no_decimals}}', noDec)
        .replace('{{amount}}', dollars);
    }

    /* ── Read parent product variant price ── */

    readParentVariantPrice() {
      var vid = '';

      // Try reading from the product form's variant ID input
      var section = this.closest('.shopify-section') || this.closest('section');
      if (section) {
        var form = section.querySelector('product-form form[data-type="add-to-cart-form"]');
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput && idInput.value) vid = idInput.value;
        }
      }

      // Fallback to the default parent variant ID from Liquid
      if (!vid) vid = this._defaultParentVariantId;
      if (!vid) return { price: 0, compareAtPrice: 0 };

      var entry = this._parentVariantPrices[vid];
      if (entry && Array.isArray(entry)) {
        return { price: entry[0] || 0, compareAtPrice: entry[1] || 0 };
      }
      return { price: 0, compareAtPrice: 0 };
    }

    /* ── Pricing ── */

    updatePricing() {
      if (!this.isPackMode()) return;

      var activeKey = this.state.activeKey;
      var hasSwitcher = !!this.packSwitcher;
      var totalCompare = 0;
      var visibleCount = 0;
      var self = this;

      this.items.forEach(function (item) {
        if (item.hidden) return;
        if (hasSwitcher && (item.getAttribute('data-pack-key') || '') !== activeKey) return;
        visibleCount++;
        var cp = parseInt(item.getAttribute('data-item-compare-price') || '0', 10);
        if (cp <= 0) cp = parseInt(item.getAttribute('data-item-price') || '0', 10);
        totalCompare += cp;

        // Update per-item value pill
        var pill = item.querySelector('.pack-item__pill');
        if (pill && cp > 0) {
          pill.textContent = 'Value ' + self.formatMoney(cp);
        }
      });

      // Include bonus items in total value (but not in bag count)
      this.bonusItems.forEach(function (item) {
        var cp = parseInt(item.getAttribute('data-item-compare-price') || '0', 10);
        if (cp <= 0) cp = parseInt(item.getAttribute('data-item-price') || '0', 10);
        totalCompare += cp;
      });

      var countEl = this.querySelector('.pack-contents__item-count');
      var countPill = this.querySelector('.pack-contents__item-count-pill');
      if (countEl) countEl.textContent = visibleCount;
      if (countPill && visibleCount > 0) countPill.hidden = false;

      var compareAmountEl = this.querySelector('.pack-contents__summary-compare-amount');
      var priceEl = this.querySelector('.pack-contents__summary-price');

      if (compareAmountEl && totalCompare > 0) {
        compareAmountEl.textContent = this.formatMoney(totalCompare);
      }

      var parentPrice = this.readParentVariantPrice();
      if (priceEl && parentPrice.price > 0) {
        priceEl.textContent = this.formatMoney(parentPrice.price);
      }
    }

    /* ── Warnings ── */

    showWarning(item, colorName) {
      var w = item.querySelector('.pack-item__warning');
      if (!w) return;
      var cs = w.querySelector('.pack-item__warning-color');
      if (cs) cs.textContent = colorName;
      w.hidden = false;

      var chooseLink = w.querySelector('.pack-item__warning-choose');
      if (chooseLink && !chooseLink.dataset.bound) {
        chooseLink.dataset.bound = 'true';
        chooseLink.addEventListener('click', function (e) {
          e.preventDefault();
          var picker = item.querySelector('.pack-item__color-picker');
          var btn = item.querySelector('.pack-item__change-color');
          if (picker) { picker.hidden = false; if (btn) btn.setAttribute('aria-expanded', 'true'); }
        });
      }
    }

    hideWarning(item) {
      var w = item.querySelector('.pack-item__warning');
      if (w) w.hidden = true;
    }

    /* ── Pack Add to Cart ── */

    initPackAddToCart() {
      var self = this;
      var section = this.closest('.shopify-section') || this.closest('section');
      if (!section) return;

      section.addEventListener('submit', function (event) {
        // Safety: ignore if this element was disconnected (stale handler)
        if (!self.isConnected) return;

        var form = event.target;
        if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
        var productFormEl = form.closest('product-form');
        if (!productFormEl) return;
        if (!self.isPackMode()) return;
        if (self.getVisibleItems().length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        self.handlePackSubmit(productFormEl, form);
      }, { capture: true, signal: this._ac.signal });
    }

    getVisibleItems() {
      var activeKey = this.state.activeKey;
      var hasSwitcher = !!this.packSwitcher;
      var visible = [];
      this.items.forEach(function (item) {
        if (item.hidden) return;
        if (hasSwitcher && (item.getAttribute('data-pack-key') || '') !== activeKey) return;
        visible.push(item);
      });
      return visible;
    }

    validatePackItems() {
      var visibleItems = this.getVisibleItems();
      if (visibleItems.length === 0) {
        return { valid: false, error: 'No pack items configured.' };
      }

      for (var i = 0; i < visibleItems.length; i++) {
        var item = visibleItems[i];
        var vid = item.getAttribute('data-variant-id');
        if (!vid) {
          var row = item.getAttribute('data-pack-row') || '';
          return { valid: false, error: 'Bag ' + row + ' has no variant selected.' };
        }

        var activeSwatch = item.querySelector('.pack-item__swatch--active');
        if (activeSwatch && activeSwatch.disabled) {
          var row2 = item.getAttribute('data-pack-row') || '';
          var colorName = activeSwatch.getAttribute('data-value') || '';
          return { valid: false, error: 'Bag ' + row2 + ' color "' + colorName + '" is sold out. Please choose another.' };
        }
      }

      // Combine identical variant IDs into quantities
      var variantCounts = {};
      for (var j = 0; j < visibleItems.length; j++) {
        var v = visibleItems[j].getAttribute('data-variant-id');
        variantCounts[v] = (variantCounts[v] || 0) + 1;
      }

      var items = [];
      var keys = Object.keys(variantCounts);
      for (var k = 0; k < keys.length; k++) {
        items.push({ id: keys[k], quantity: variantCounts[keys[k]] });
      }

      return { valid: true, items: items };
    }

    handlePackSubmit(productFormEl, form) {
      var submitButton = productFormEl.querySelector('[type="submit"]');
      if (!submitButton) return;
      if (submitButton.getAttribute('aria-disabled') === 'true') return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      var multiplier = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var validation = this.validatePackItems();
      if (!validation.valid) {
        this.showFormError(productFormEl, validation.error);
        return;
      }

      var items = validation.items.map(function (item) {
        return { id: item.id, quantity: item.quantity * multiplier };
      });

      // Append bonus items (qty 1 each)
      this.bonusItems.forEach(function (item) {
        var vid = item.getAttribute('data-variant-id');
        if (vid) items.push({ id: vid, quantity: 1 });
      });

      this.clearFormError(productFormEl);
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');

      var self = this;
      var cart = document.querySelector('cart-drawer') || document.querySelector('main-cart');
      var hasError = false;

      // Pre-filter benefits (skip if already in cart) then add
      var filterPromise = (window.CartBenefits && typeof window.CartBenefits.filterBenefitsFromItems === 'function')
        ? window.CartBenefits.filterBenefitsFromItems(items)
        : Promise.resolve(items);

      filterPromise.then(function (filteredItems) {
      if (filteredItems.length === 0) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        return;
      }

      // Build JSON body for multi-item add (more reliable than indexed FormData)
      var body = { items: filteredItems };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) {
            hasError = true;
            self.showFormError(productFormEl, response.description || response.message || 'Could not add pack to cart.');
            return;
          }

          var isCartPage = document.body.classList.contains('template-cart');
          if (isCartPage) { window.location = window.routes.cart_url; return; }
          if (!cart) { window.location = window.routes.cart_url; return; }

          var desktopAction = cart.getAttribute('data-action-add-cart-desktop');
          if (desktopAction === 'page' && window.innerWidth > 767) {
            window.location = window.routes.cart_url; return;
          }

          cart.renderContents(response);
          self.openCartDrawer(cart);
        })
        .catch(function (e) {
          console.error('Pack add to cart error:', e);
          hasError = true;
          var msg = (window.cartStrings && window.cartStrings.error) || 'There was an error. Please try again.';
          self.showFormError(productFormEl, msg);
        })
        .finally(function () {
          submitButton.classList.remove('loading');
          var label = submitButton.querySelector('.hidden-on-load');
          if (label) label.classList.remove('opacity-0');
          if (!hasError) submitButton.removeAttribute('aria-disabled');
          document.dispatchEvent(new CustomEvent('nextsky:cart:added', { detail: { success: !hasError } }));
        });
      }); // end filterPromise.then
    }

    openCartDrawer(cart) {
      document.documentElement.classList.add('open-modal');
      cart.classList.remove('content-hidden');
      cart.classList.add('active', 'remove');
      document.dispatchEvent(new CustomEvent('modal:opened'));
    }

    showFormError(productFormEl, message) {
      var wrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
      if (wrapper) {
        var span = wrapper.querySelector('.product-form__error-message');
        if (span) span.textContent = message;
        wrapper.hidden = false;
      }
    }

    clearFormError(productFormEl) {
      var wrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
      if (wrapper) wrapper.hidden = true;
    }

    /* ── Cleanup ── */

    disconnectedCallback() {
      // Abort all event listeners attached via this._ac
      if (this._ac) this._ac.abort();
      if (this._initRAF) cancelAnimationFrame(this._initRAF);
      if (this._variantObserver) this._variantObserver.disconnect();
      if (this._syncDebounce) cancelAnimationFrame(this._syncDebounce);
    }
  }

  if (!customElements.get('pack-contents')) {
    customElements.define('pack-contents', PackContentsElement);
  }
})();
